/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconWoodenSign: {
  name: 'wooden_sign';
  data: string;
} = {
  name: 'wooden_sign',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m573.744 424.086-7.644-85.5-179.022-4.689 177.558-11.683-10.549-117.999-177.193-4.416 191.743-12.002-1.899-87.836-234.634 5.072-1.38-49.516c-1.698-34.631-95.88-30.503-93.892 6.79l1.263 44.758-209.318 4.524 1.838 85.033 196.058 4.876-188.286 11.761-3.726 126.83 10.643 2.43-9.521 93.195 211.456-4.571 4.871 172.643h93.891l-4.867-174.672 232.61-5.028z"/></svg>`,
};
